module.exports = __webpack_public_path__ + "static/ay-not-dead-e618565252a6edc333b1dbc709ebff8e.jpg";